import set from './src/set/index.js';
import get from './src/get/index.js';
import remove from './src/remove/index.js';

const hardtack = {
  set,
  get,
  remove,
};

export default hardtack;
